export const removeReferences = (key) => {
  let processedString = key;
  if (key.startsWith("-")) processedString = key.substring(1);

  const allEndsWithMatches = [
    ...key.matchAll(/(\[\d*\]|\(\d*\)|\*+|<sup>\d*<\/sup>)$/gi),
  ];
  if (allEndsWithMatches.length > 0) {
    return key.substring(0, allEndsWithMatches.pop()?.index);
  }
  return processedString;
};

export const standardizeKey = (key) => {
  if (key !== undefined)
    return removeReferences((key || "").replaceAll(" ", "").toLowerCase());
};

export const standardizeObjectKeys = (object = {}) => {
  return Object.fromEntries(
    Object.entries(object).map(([key, value]) => [standardizeKey(key), value])
  );
};

export const standardizeObjectValues = (object = {}) => {
  return Object.fromEntries(
    Object.entries(object).map(([key, value]) => [key, standardizeKey(value)])
  );
};
